import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { supabaseClient } from "../../component/supabaseClient";
import { useNavigate } from "react-router-dom";
import { MuiTheme } from "../../styles/MuiDataTableStyle";
import MUIDataTable from "mui-datatables";
import LoadingModal from "../../component/modals/LoadingModal";
import {MdEdit} from "react-icons/md";
import {
  textLabels,
  downloadOptions,
  sortFunction,
} from "../../utils/MuiTableOptions";
import { GoBackButton } from "../../component/GoBackButton";
import { errAndMsg } from "../../utils/MsgAlert";

function Medida() {
  const navigate = useNavigate();

  const [medida, setMedida] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getMedida = async () => {
      const { data, error } = await supabaseClient
        .from("medida")
        .select()
        .eq("mostrar", true)
        .order("medidaId", { ascending: true });
      if (error) errAndMsg("Error", error.message, error.code);
      data && setMedida(data);
    };
    getMedida();
  }, []);

  const editMedida = (event) => {
    // eslint-disable-next-line array-callback-return
    medida?.map((m) => {
      if (m.medidaId === parseInt(event.currentTarget.id)) {
        navigate("editar-medida", {
          state: {
            medida: m,
          },
        });
      }
    });
  };

  const columns = [
    {
      name: "medidaId",
      label: "Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
        customBodyRender: (value) => (
          <div style={{ textAlign: "center" }}>{value}</div>
        ),
      },
    },
    {
      name: "descripcion",
      label: "Descripcion",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <div className="crud__table__icon-container">
              <MdEdit
                id={medida[dataIndex].medidaId}
                style={{ cursor: "pointer" }}
                className="crud__table__icon"
                alt="Item menú"
                onClick={editMedida}
              />
            </div>
          );
        },
        filter: false,
        sort: false,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
  ];

  const options = {
    searchOpen: true,
    textLabels,
    downloadOptions,
    filter: true,
    selectableRows: "none",
    fixedHeader: false,
    filterType: "dropdown",
    responsive: "standard",
    customSort: sortFunction,
    draggableColumns: { enabled: true },
  };

  return (
    <>
      <ThemeProvider theme={MuiTheme}>
        <div className="crud">
        <div className="crud__title">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <GoBackButton />
              <div style={{ width: "100%" }}>
                <h3>Medidas</h3>
              </div>
            </div>
            <hr />
          </div>
          <MUIDataTable
            title={"Listado de medidas"}
            data={medida}
            columns={columns}
            options={options}
          />
          <div className="crud__rigth-buttons-container">
            <button
              className="btn btn-dark"
              onClick={() => {
                navigate("agregar-medida", { state: { medida: false } });
              }}
            >
              Agregar nueva medida
            </button>
          </div>
        </div>
        <LoadingModal
          text="Eliminando medida..."
          show={loading}
          setShow={setLoading}
        />
      </ThemeProvider>
    </>
  );
}

export default Medida;
